import { render } from "./UserProfileMudurlukSvg.vue?vue&type=template&id=b790afd2"
import script from "./UserProfileMudurlukSvg.vue?vue&type=script&lang=js"
export * from "./UserProfileMudurlukSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__